import React, { useState } from "react";
import HeaderPrelogin from "./header";
import ApiService from '../../services/api.service';
import Loader from '../common/Loader'

function Selfservice({ setPage, setSuccessVisible, setMessage, serUserNameProp }) {
    const [actionState, setActionState] = useState("password")
    const [error, setError] = useState('')
    const [phone, setPhone] = useState();
    const [username, setUsername] = useState();
    // const [verifyClass, setVerifyClass] = useState('grayout')
    const [verifyClass, setVerifyClass] = useState('grayout')
    const [otpsent, setOTPSent] = useState(false)
    const [otpValue, setOtpValue] = useState("")
    const [loader, showLoader] = useState(false);
    const [otpState, setOtpState] = useState("r")
    const [navig, getPage] = useState("login")
    const handleOnchange = (val) => {
        val.length >= 6 ? setVerifyClass("active") : setVerifyClass('grayout')
    }
    const [verifiedUser, setverifiedUser] = useState(false)
    const verifyOtp = (e) => {
        e.preventDefault()
        const payload = {
            "username": username,
            "otp": otpValue
        }
        ApiService.post("/auth/validate_otp", payload).subscribe(
            (res) => {
                showLoader(false)
                if ((res.data !== undefined || res.data !== null) && res.data.valid) {
                    setOtpState("s")
                    if (actionState === 'password') {
                        setverifiedUser(true)
                        serUserNameProp(username)
                    }
                } else {
                    setError("Invalid OTP")
                }
            });
    }


    const changePassword = (e) => {
        e.preventDefault();
        try {
            let payload = { "mobileNumber": phone, "type": actionState === "password" ? 2 : 1 }
            let uri = '/auth/recover_account';
            ApiService.post(uri, payload).subscribe((res) => {
                if (res.data !== undefined && res.data !== null) {

                } else {
                    setError("An error occurred");
                }
            })
        } catch (e) {
            console.log("An error occurred" + e)
        } finally {

        }
        // setPage("password")
    }


    const sendOTP = (e) => {
        e.preventDefault();
        showLoader(true)
        try {
            let payload = { "mobileNumber": username, "type": actionState === "password" ? 2 : 1 }
            let uri = '/auth/recover_account';
            ApiService.post(uri, payload).subscribe((res) => {
                showLoader(false)
                if (res.status === 200) {
                    setOTPSent(true)
                    setOtpState("v")

                } else if (notEmpty(res.response) && notEmpty(res.response.data) && notEmpty(res.response.data.status)) {
                    setError(res.response.data.error)

                } else {
                    setError("An error occurred");
                }

            })
        } catch (e) {
            console.log("An error occurred" + e)
        } finally {

        }
    }



    const recoverUsername = (e) => {
        e.preventDefault();
        showLoader(true)
        try {
            let payload = { "mobileNumber": phone, "type": actionState === "password" ? 2 : 1 }
            let uri = '/auth/recover_account';
            ApiService.post(uri, payload).subscribe((res) => {
                showLoader(false)



                if (res.status === 200) {
                    setSuccessVisible(true)
                    setMessage("Your username has been sent to your registered phone number successfully")

                } else if (notEmpty(res.response) && notEmpty(res.response.data) && notEmpty(res.response.data.status)) {
                    setError(res.response.data.error)

                } else {
                    setError("An error occurred");
                }


            })
        } catch (e) {
            console.log("An error occurred" + e)
        } finally {

        }

    }






    return (
        <div className="self_service">
            <Loader loader={loader} />
            <HeaderPrelogin journey="Self Service" getPage={navig} />
            <div className="self_service_wrapper">
                <h3 className="self_service_wrapper_heading">
                    I have trouble logging in
                </h3>
                <form className="verify_wrapper_form">
                    <div className="verify_wrapper_form_container">
                        <label htmlFor="select_wallet" className="verify_wrapper_form_label">
                            Login issue
                        </label>
                        <select onChange={(e) => setActionState(e.target.value)} name="wallets" className="verify_wrapper_form_input" id="select_wallet">
                            <option value="password">Forgot password</option>
                            <option value="username">Forgot username</option>
                        </select>
                    </div>

                    <div className="verify_wrapper_form_container">
                        <label className="verify_wrapper_form_label">
                            {actionState === "username" ? "Mobile number" : "Username"}
                        </label>
                        {actionState === "password" && <input value={username} onChange={(e) => { handleOnchange(e.target.value); setUsername(e.target.value); setError('') }} type="text" placeholder="Enter username" className="verify_wrapper_form_input" />}
                        {actionState === "username" && <input value={phone} onChange={(e) => { handleOnchange(e.target.value); setPhone(e.target.value); setError('') }} type="tel" placeholder="0736000000" className="verify_wrapper_form_input" />}
                    </div>
                    <div className={`verify_wrapper_form_container ${actionState === "password" ? "" : 'smooth-toggle-element'}`}>
                        <label className="verify_wrapper_form_label">
                            Verification code
                        </label>
                        <div className="verify_wrapper_form_container_sub">
                            <input onChange={(e) => {
                                // Handle paste
                                var regex = /[0-9]|\./;

                                if (regex.test(e.target.value)) {
                                    setOtpValue(e.target.value)
                                }


                            }} placeholder="x x x x" type="text" id="farmer_id" className="verify_wrapper_form_input" />
                            {otpState === "s" && <button onClick={(e)=>{e.preventDefault()} } className="verify_wrapper_form_btn_verify" ><svg height={10} width={10} id="icon-checkmark" viewBox="0 0 32 32">
                                <path d="M27 4l-15 15-7-7-5 5 12 12 20-20z"></path>
                            </svg></button>}
                            {(otpState === "r" || otpState === "v") && <button className={`verify_wrapper_form_btn_verify ${verifyClass}`} onClick={(e) => { !otpsent ? sendOTP(e) : verifyOtp(e) }}>
                                {otpsent ? "Verify OTP" : "Get OTP"}
                            </button>
                            }
                        </div>

                    </div>

                    {error !== "" ? <>
                        <label htmlFor="farmer_id" className="verify_wrapper_form_label error_label invalid_id">
                            {error}
                        </label> </> : <></>
                    }



                </form>

            </div>

            <div className="verify_wrapper_form_container_btns">
                <button onClick={() => setPage("login")} className="verify_wrapper_form_btn_verify select back">
                    Back
                </button>
                {actionState === "password" && verifiedUser ? <button onClick={(e) => verifiedUser ? setPage("recover") : console.log("Action not permitted")} className="verify_wrapper_form_btn_verify select"> Next  </button>
                    : actionState === "password" && !verifiedUser ? <button onClick={(e) => verifiedUser ? changePassword(e) : console.log("Action not permitted")} className="verify_wrapper_form_btn_verify select btn-inactive"> Next  </button>
                        : <button onClick={(e) => actionState === "password" ? changePassword(e) : actionState === "username" ? recoverUsername(e) : console.log("unspecified action")} className="verify_wrapper_form_btn_verify select">Next</button>
                }
            </div>
        </div>
    );
}

export const notEmpty = (str) => {
    if (str !== undefined && JSON.stringify(str).length > 0 && str !== "") {
        return true
    }
    return false
}

export default Selfservice;
